module.exports = __webpack_public_path__ + "static/media/lifeline_step_9.3f889e11.png";